import { render, staticRenderFns } from "./4MRiskHazard.vue?vue&type=template&id=18f04ab3"
import script from "./4MRiskHazard.vue?vue&type=script&lang=js"
export * from "./4MRiskHazard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18f04ab3')) {
      api.createRecord('18f04ab3', component.options)
    } else {
      api.reload('18f04ab3', component.options)
    }
    module.hot.accept("./4MRiskHazard.vue?vue&type=template&id=18f04ab3", function () {
      api.rerender('18f04ab3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/base/4MRiskHazard.vue"
export default component.exports